import * as React from 'react';
import useWidget from '@Utils/core/useWidget';
import { WidgetId } from '@Utils/edge/constants';
import useMediaQuery from '@Utils/core/hooks/useMediaQuery-v3';
import useOnClickOutside from '@Utils/shared/hooks/useOnClickOutside';
import DropdownContext from './DropdownContext';
import OpenedSection from './OpenedSection';
import MobileOpenedSection from './MobileOpenedSection';
import * as Styled from './Dropdown.styled';

const Dropdown: React.FC = () => {
  const { isMobileOrTablet } = useMediaQuery();

  const [isOpen, setIsOpen] = React.useState(false);
  const widgetGeneratorDropdown = useWidget(WidgetId.GeneratorDropdownV3);
  const widgetGeneratorDropdownActiveV3 = useWidget(WidgetId.GeneratorDropdownActiveV3);

  const activeValue = widgetGeneratorDropdownActiveV3.options.activeValue;

  const ref = React.useRef<HTMLInputElement>(null);

  const handleDropDown = () => {
    setIsOpen(!isOpen);
  };

  useOnClickOutside(ref, () => {
    if (!isMobileOrTablet) {
      setIsOpen(false);
    }
  });

  const mainTitle = widgetGeneratorDropdown.repeaters.group.find(
    (item) => item.options.value === activeValue,
  );

  return (
    <DropdownContext.Provider
      value={{
        isOpen: isOpen,
        setIsOpen: setIsOpen,
      }}
    >
      <Styled.DropDown ref={ref}>
        <Styled.DropDownValue onClick={handleDropDown} isActive={isOpen}>
          <span>{mainTitle && mainTitle.strings.title}</span>
          <Styled.ColumnIcon />
        </Styled.DropDownValue>
        {isMobileOrTablet ? <MobileOpenedSection /> : <OpenedSection />}
      </Styled.DropDown>
    </DropdownContext.Provider>
  );
};

export default Dropdown;
